import { merchantPersonPhoneChallengeIdFormat } from "@redotech/redo-account-id";
import * as z from "zod";

export const verifyLinkMerchantPhone = {
  name: "verifyLinkMerchantPhone" as const,
  input: z.object({
    challengeId: merchantPersonPhoneChallengeIdFormat.schema,
    code: z.string().regex(/^\d{6}$/),
  }),
  output: z.object({ phoneE164: z.string() }),
};
